import { render, staticRenderFns } from "./GLTitleCell.vue?vue&type=template&id=2d0e027c&scoped=true"
import script from "./GLTitleCell.vue?vue&type=script&lang=js"
export * from "./GLTitleCell.vue?vue&type=script&lang=js"
import style0 from "./GLTitleCell.vue?vue&type=style&index=0&id=2d0e027c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d0e027c",
  null
  
)

export default component.exports